import React from 'react';
import { MapPin } from '@phosphor-icons/react';

function TaskLocationCard({ client }) {
  const coordinates = client?.lat && client?.lng
    ? `${client.lat}, ${client.lng}`
    : client?.fakeLat && client?.fakeLng
      ? `${client.fakeLat}, ${client.fakeLng}`
      : null;

  if (!client?.address && !coordinates) {
    return null;
  }

  return (
    <section className="rounded-3xl border border-line bg-surface/80 p-6 shadow-lg shadow-black/10">
      <div className="mb-5 flex items-center gap-3">
        <div className="rounded-xl bg-surface-2 p-2 text-content-muted">
          <MapPin size={20} />
        </div>
        <h2 className="text-lg font-semibold text-content">Ubicación</h2>
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        <div className="rounded-2xl bg-bg/35 p-4">
          <p className="mb-2 text-sm text-content-muted">Dirección del cliente</p>
          <p className="text-base font-medium text-content">{client?.address || 'Sin dirección registrada'}</p>
        </div>
        <div className="rounded-2xl bg-bg/35 p-4">
          <div className="mb-2 flex items-center gap-2 text-sm text-content-muted">
            <span>Coordenadas</span>
          </div>
          <p className="text-base font-medium text-content">{coordinates || 'Sin coordenadas registradas'}</p>
        </div>
      </div>
    </section>
  );
}

export default TaskLocationCard;
